import isArray from 'lodash/isArray';
import sortBy from 'lodash/sortBy';

import CircleIcon from '@mui/icons-material/Circle';

import config from '../config/config';
import {capitalize} from './stringUtils';
import {formatPlanCategory} from './payerPlans';

export const isDirectBilling = c => {
  if (!c) return false;
  const directBillTypes = [
    'DIRECT_BILL', 
    'WORK_COMP', 
    'COMMERCIAL',
    'AUTO', 
    'LIEN',
    'CORRECTIONS',
  ];
  const isDirectBillType = directBillTypes.includes(c?.billing_category);
  return isDirectBillType;
};

export const getCaseLink = c => {
  return `/providers/cases/view/${c.id}`;
};

export const formatCaseName = c => {
  if (!isArray(c?.diagnosis_categories)) return '';
  return c.diagnosis_categories.reduce((acc, next, i) => (
    acc + (i ? ', ' : '') + next.name
  ), '');
};

export const formatCaseBillingType = c => {
  let billingCategory = '';
  switch (c?.billing_category) {
    case 'DIRECT_BILL':
      billingCategory = 'Direct Bill';
      break;
    case 'CASH':
      billingCategory = 'Cash';
      break;
    case 'COURTESY_BILL':
      billingCategory = 'Courtesy Bill';
      break;
    default:
      billingCategory = '';
  }
  if (c?.billing_category === 'DIRECT_BILL') {
    switch (c?.payer_plan?.category) {
      case 'AUTO':
        billingCategory += ' - Auto';
        break;
      case 'WORK_COMP':
        billingCategory += ' - Workers Comp';
        break;
      case 'COMMERCIAL':
        billingCategory += ' - Commercial';
        break;
      case 'LIEN':
        billingCategory += ' - Lien';
        break;
      case 'CORRECTIONS':
        billingCategory += ' - Corrections';
        break;
      default:
        billingCategory += '';
    }
  }
  return billingCategory;
};

export const getCaseStatusOptions = c => {
  let options;
  const status = capitalize(c?.status || '');
  switch (status) {
    case 'ACTIVE':
      options = {
        Icon: CircleIcon,
        color: config().colors.primary,
        name: 'Active',
      };
      break;
    case 'GOALS_MET':
      options = {
        Icon: CircleIcon,
        color: config().colors.success,
        name: 'Completed',
      };
      break;
    case 'REFERRED_OUT': 
      options = {
        Icon: CircleIcon,
        color: config().colors.teal,
        name: 'Referred Out',
      };
      break;
    case 'LOST': 
      options = {
        Icon: CircleIcon,
        color: config().colors.error,
        name: 'Lost',
      };
      break;
    default:
      options = {
        Icon: CircleIcon,
        color: config().colors.light,
        name: 'NA',
      };
  }
  return options;
};

export const getDefaultCase = (cases, {providerId} = {}) => {
  const newestCases = sortBy(cases || [], 'created_at', 'desc');
  const caseData = newestCases.find(c => 
    c.status === 'ACTIVE'
    && c.providers.find(p => p.id === providerId)
  );
  return caseData;
};